module.exports = __webpack_public_path__ + "img/fasolya-khadra.b175e83c.png";